// Formatador unico de dinheiro para exibicao: sempre "R$ 1.234,50" (pt-BR).
// Antes cada tela montava o texto na mao ("R$ " + toFixed(2) -> "R$ 20.00",
// ou sem o "R$"), e o admin/OrderViewer usavam Intl com o espaco nao-quebravel.
//
// O Intl separa "R$" do numero com NBSP (U+00A0); normalizamos para espaco
// comum para o texto ser igual em tela, no WhatsApp e nos testes.
//
// So para EXIBICAO: valores enviados ao backend continuam numericos.
const brl = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export function formatBRL(value: number | string | null | undefined): string {
  const num = typeof value === "string" ? Number.parseFloat(value) : value;
  const safe = typeof num === "number" && Number.isFinite(num) ? num : 0;
  return brl.format(safe).replace(/ /g, " ");
}
